
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#e9576a","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-2766 -457.449)"}},[_c('path',{attrs:{"data-name":"Path 1846","d":"M2774 457.449a8 8 0 11-8 8 8 8 0 018-8z","fill":"inherit"}}),_c('rect',{attrs:{"data-name":"Rectangle 1277","width":"8.91","height":"2.228","rx":"1","transform":"translate(2769.545 464.335)","fill":"#2e2c34"}})])])
          )
        }
      }
    